/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:03:14
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:29:18
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\stores\xm-tenant-select.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SelectProps } from 'ant-design-vue'
import { useXmAgentAndIndustryToggleStore } from '.'
import {dbUtils} from 'xmgoing-utils'

export const useXmTenantSelectStore = defineStore('xm-tenant-select', () => {
  const XmAgentAndIndustryToggleStore = useXmAgentAndIndustryToggleStore()

  const {
    tenantList
  } = storeToRefs(XmAgentAndIndustryToggleStore)

  const industryList = ref([])

  const selectProps = computed<SelectProps>(() => {
    const userInfo = dbUtils.getCachUser()
    const id = userInfo.id
    const value = id
    return {
      value,
      options: tenantList.value,
      bordered: false
    }
  })

  const onChange: SelectProps['onChange'] = (value, selectedOption) => {
    console.log(value)
    console.log(selectedOption)
  }

  const isMultiple = computed(() => {
    return tenantList.value.length > 1
  })

  return {
    isMultiple,
    selectProps,
    industryList,
    onChange
  }
})
